import React, {useState} from "react";
import {FaList} from "react-icons/fa";
import moment from "moment";
import {Segmented} from "antd";
import ExtractorSectionCode from "./ExtractorSectionCode";
import ExtractorSectionUi from "./ExtractorSectionUi";
import {IoCodeSlash} from "react-icons/io5";

const ExtractorSection = ({currentData, getExtractionData, width}) => {
    const [currentTab, setCurrentTab] = useState("ui");

    return (
        <div className="px-3">
            <div className="my-1 text-xs font-medium text-gray-700 flex justify-between items-center">
                <p>EDIT TEMPLATE</p>
                <div className={'flex'}>
                    <div className="text-gray-500 text-xs px-4 flex items-center">
                        {currentData?.template_updated_at && (
                            <p>Last saved
                                at {moment(currentData.template_updated_at).format("h:mm A, MMM DD, YYYY")}</p>
                        )}
                    </div>
                    <Segmented
                        options={[
                            {
                                label: "",
                                value: "ui",
                                icon: <FaList className="mt-1.5 w-3.5 h-3.5"/>,
                            },
                            {
                                label: "",
                                value: "code",
                                icon: <IoCodeSlash className="mt-1.5 w-4 h-4"/>,
                            },
                        ]}
                        onChange={(value) => {
                            setCurrentTab(value);
                        }}
                    />
                </div>
            </div>
            {currentTab === "ui" ? (
                <ExtractorSectionUi currentData={currentData} getExtractionData={getExtractionData}/>
            ) : (
                <ExtractorSectionCode currentData={currentData} getExtractionData={getExtractionData} width={width}/>
            )}
        </div>
    );
};

export default ExtractorSection;
